export const APP_ROUTES = {
  HOME: "/",
  DEFAULT: "*",
};
